import React, { useEffect, useMemo } from 'react';
import PageLayout from '../../../components/common/PageLayout';
import Hero from '../../../components/common/Hero';
import Box from '../../../components/common/Box';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getWarehouse } from '../../../store/actions/warehouses';
import Spinner from '../../../components/common/Spinner';
import { EditNetSuiteWarehouseForm } from '../../../components/forms/EditNetSuiteWarehouseForm';
import { EditSalesforceWarehouseForm } from '../../../components/forms/EditSalesforceWarehouseForm';
import { EditCin7Form } from '../../../components/forms/Cin7Forms';

export const warehousesIntegrationForms = {
  netsuite: EditNetSuiteWarehouseForm,
  salesforce_commerce_cloud: EditSalesforceWarehouseForm,
  cin7: EditCin7Form,
};

export function WarehouseEditContainer() {
  const dispatch = useDispatch();
  const { warehouseId } = useParams();
  const { warehouse, isLoadingWarehouse } = useSelector((state) => state.warehouses);

  const renderIntegrationForm = () => {
    const integrationComponent = warehousesIntegrationForms[warehouse.orders_integration_type];
    return React.createElement(integrationComponent, { warehouse });
  };

  useEffect(() => {
    dispatch(getWarehouse(warehouseId));
  }, [dispatch, warehouseId]);

  const hero = useMemo(() => <Hero title="Warehouse Configuration" />, []);
  const isAllowedIntegration = useMemo(
    () =>
      !isLoadingWarehouse && warehouse
        ? warehousesIntegrationForms.hasOwnProperty(warehouse.orders_integration_type)
        : false,
    [warehouse, isLoadingWarehouse],
  );

  return (
    <PageLayout top={hero}>
      {isLoadingWarehouse ? (
        <Spinner size="large" />
      ) : (
        <div style={{ width: 600, margin: '0 auto' }}>
          <Box>
            {isAllowedIntegration ? (
              renderIntegrationForm()
            ) : (
              <>
                <h3>You can't edit this type of warehouse.</h3>
                <p>
                  Please contact{' '}
                  <a style={{ color: 'black' }} href="mailto:support@cym.bio">
                    support@cym.bio
                  </a>
                </p>
              </>
            )}
          </Box>
        </div>
      )}
    </PageLayout>
  );
}
